import { useQuery } from "@tanstack/react-query";
import { PlugZap } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

export const useIntegrations = () =>
  useQuery({ queryKey: ["platform-status"], queryFn: () => api.get("/platform/status").then((r) => r.data) });

const STATUS = {
  configured: ["Configuré", "bg-success/15 text-success"],
  not_configured: ["Clé manquante", "bg-warning/15 text-warning"],
  planned: ["Bientôt disponible", "bg-secondary text-muted-foreground"],
};

const Row = ({ i }) => (
  <li className="flex items-center justify-between gap-3 py-3" data-testid={`integration-${i.key}`}>
    <span className={cn("flex items-center gap-3 text-sm", i.status === "planned" && "text-muted-foreground")}><PlugZap className="h-4 w-4 text-muted-foreground" />{i.name}</span>
    <span className={cn("shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-semibold", STATUS[i.status][1])} data-testid={`integration-status-${i.key}`}>{STATUS[i.status][0]}</span>
  </li>
);

export const IntegrationList = ({ filter }) => {
  const { data } = useIntegrations();
  const items = (data?.integrations || []).filter((i) => !filter || filter.includes(i.key));
  const live = items.filter((i) => i.status !== "planned");
  const planned = items.filter((i) => i.status === "planned");
  return (
    <div data-testid="integration-list">
      {live.length > 0 && <><div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Actives dans CASHMY</div>
        <ul className="divide-y divide-border">{live.map((i) => <Row key={i.key} i={i} />)}</ul></>}
      {planned.length > 0 && <><div className={cn("text-xs font-semibold uppercase tracking-wider text-muted-foreground", live.length && "mt-5")}>Prévues (pas encore développées)</div>
        <ul className="divide-y divide-border">{planned.map((i) => <Row key={i.key} i={i} />)}</ul></>}
    </div>
  );
};
